import {Component, OnInit} from '@angular/core';
import {PtyLdService} from "../../services/pty-ld.service";
import {NavParams, PopoverController} from "@ionic/angular";
import {ActivatedRoute, Router} from "@angular/router";
import {PtyWsService} from "../../services/pty-ws.service";
import {AuthService} from "../../services/auth.service";
import {TranslationService} from "../../services/translation.service";

@Component({
    selector: 'app-seeker-duplicate-merge',
    templateUrl: './seeker-duplicate-merge.component.html',
    styleUrls: ['./seeker-duplicate-merge.component.scss'],
})
export class SeekerDuplicateMergeComponent implements OnInit {
    info: any = null;
    merge_to_seeker: any;
    currentSeekerUUID: string;
    seekers: any = [];
    languages: any = [];
    communities: any = [];

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private popCtrl: PopoverController,
        private auth: AuthService,
        private ld: PtyLdService,
        private ws: PtyWsService,
        private navParams: NavParams,
        private _translationService: TranslationService
    ) {
        this.info = this.navParams.get('event');

        if (this.info != null) {
            this.currentSeekerUUID = this.info.seeker_uuid;
            this.languages = this.info.languages;
            this.communities = this.info.communities;
        }
    }

    ngOnInit() {
        this.loadSeekers()
    }

    loadSeekers() {
        let self = this;
        this.ld.showLoading(true);
        self.ws.invokeURL('get_my_seekers', {}).subscribe((resp: any) => {
            this.seekers = resp.result.rows;
            this.ld.showLoading(false);
        }, (err: any) => {
            this.ld.showLoading(false);
            self.ld.showToast(this._translationService.translate('UnknownError'));
        });
    }

    mergeDuplicate() {
        let self = this;
        this.ld.showLoading(true);
        self.ws.invokeURL('merge_seekers', {
            current_seekerUUID: this.currentSeekerUUID,
            merge_to_seekerUUID: this.merge_to_seeker
        }).subscribe((resp: any) => {
            if (resp.error === 0) {
                this.dismiss();
                this.router.navigate(['/home']);
            }
            this.ld.showLoading(false);
        }, (err: any) => {
            this.ld.showLoading(false);
            self.ld.showToast(this._translationService.translate('UnknownError'));
        });
    }

    async dismiss() {
        await this.popCtrl.dismiss();
    }
}
